import React from "react";
import styles from "./sidebarFormStyles.module.css";
import { LucideIcon } from "../../icon/LucideIcon";

interface EntityFilterBarProps {
  onReset: (e: React.MouseEvent) => void;
  children: React.ReactNode;
  hideReset?: boolean;
  hideCustomFilters?: boolean;
}
export const EntityFilterSideBar = ({ onReset, children, hideReset = false }: EntityFilterBarProps) => {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
      }}
      autoComplete="off"
      className={styles.form_container}
      style={{ width: "max-content" }}
    >
      <div
        className="flex col-nowrap"
        style={{
          // width: "100%",
          // height: "fit-content",
          overflowX: "hidden",
          overflowY: "auto",
          paddingRight: "5px",
          flex: "1 1 100%",
        }}
      >
        {children}
      </div>
      {!hideReset && (
        <div className="flex col-nowrap gap-5" style={{ width: "100%", padding: "0px 5px" }}>
          <hr style={{ width: "100%", margin: 0 }} />

          <button type="reset" className="btn btn-sm btn-ghost-secondary btn-block" onClick={onReset}>
            <LucideIcon name="refresh-ccw" /> Reset filters
          </button>
        </div>
      )}
    </form>
  );
};
